import { z } from "zod";

export const RemoveVehicleRequestSchema = z
	.object({
		model: z.string(),
		vehicleId: z.string(),
		year: z.string(),
	})
	.transform(({ year, ...rest }) => ({
		...rest,
		modelYear: year,
		reason: "disposed" as const,
	}));
